export default {
    resizableSides: [],
    defaultMobileProperties: {
        size: 'standard'
    }
}
